var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " ",
    clipPath: "url(#clip0_6448_7161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7958 0.00714502C11.7332 0.0133753 11.5347 0.0316964 11.3547 0.0478838C6.90166 0.447847 2.97585 3.39666 1.32706 7.58005C0.747286 9.05103 0.5 10.3712 0.5 11.9956C0.5 12.9405 0.55475 13.5382 0.714902 14.3426C1.34103 17.4872 3.20424 20.2466 5.90577 22.0301C8.28723 23.6024 11.1983 24.2713 14.0409 23.8996C15.5665 23.7001 17.0861 23.1959 18.3791 22.4601C21.3003 20.7979 23.365 18.075 24.1568 14.8405C24.9483 11.6073 24.3562 8.1746 22.5301 5.41011C21.1562 3.33009 19.195 1.73286 16.9097 0.83259C15.8517 0.415842 14.8732 0.178123 13.6739 0.0465753C13.3871 0.0150823 12.007 -0.0138503 11.7958 0.00714502ZM14.0434 11.0614C12.3741 13.1477 10.9991 14.8581 10.9878 14.8623C10.9765 14.8666 10.2573 14.2617 9.3896 13.5182C8.52185 12.7747 7.80413 12.1663 7.79465 12.1663C7.77294 12.1663 6.62259 13.5052 6.63562 13.5154C6.64089 13.5195 7.67383 14.4037 8.93106 15.4802C11.1551 17.3845 11.2183 17.436 11.2681 17.3836C11.2962 17.354 12.9105 15.339 14.8553 12.9059C16.8002 10.4728 18.4098 8.46083 18.4324 8.43477C18.4694 8.39192 18.4113 8.33793 17.8236 7.86861C17.4664 7.58326 17.1526 7.33141 17.1263 7.3089C17.083 7.27178 16.8004 7.61569 14.0434 11.0614Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6448_7161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessSolid);
export default __webpack_public_path__ + "static/media/icon--success-solid.83c177a1fd9ecc47cc366dd13dbfe63c.svg";
export { ForwardRef as ReactComponent };